module.exports = new __parcel__URL__("project-with-shared-configuration-icon.e5c37209.svg").toString();